import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { TransbankService, TransbankConfig, TransbankTerminal, TransbankTransaccion, TransbankWebhookLog } from 'src/app/api/transbank.service';
import { Config, DefaultConfig } from 'ngx-easy-table';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-terminales-transbank',
  templateUrl: './terminales-transbank.component.html',
  styleUrls: ['./terminales-transbank.component.css']
})
export class TerminalesTransbankComponent implements OnInit, AfterViewInit, OnDestroy {

  // ── Referencias a plantillas de ngx-table ────────────────────────────────
  @ViewChild('frmAccion') frmAccion!: TemplateRef<any>;
  @ViewChild('frmAmbiente') frmAmbiente!: TemplateRef<any>;

  // ── Pestañas activas ──────────────────────────────────────────────────────
  tabActiva: 'terminales' | 'transacciones' | 'webhook' | 'pruebas' = 'terminales';

  // ── Estado general ────────────────────────────────────────────────────────
  cargando = false;
  mensaje = '';
  mensajeError = '';

  // ── Config del comercio ───────────────────────────────────────────────────
  cargandoConfig = false;
  guardandoConfig = false;
  config: TransbankConfig = {
    integracion: { commerceCode: '', apiKey: '' },
    produccion:  { commerceCode: '', apiKey: '' },
    urlNotify: 'https://terraapi.indeone.app/api/Transbank/webhook',
    activoProduccion: false,
    activoLocalhost: false
  };

  // ── Terminales ────────────────────────────────────────────────────────────
  terminales: TransbankTerminal[] = [];
  editandoTerminal = false;
  terminalSeleccionado: TransbankTerminal = this.nuevoTerminalVacio();

  // ── Historial de Transacciones ────────────────────────────────────────────
  transacciones: TransbankTransaccion[] = [];
  cargandoTransacciones = false;

  // ── Logs de Webhook ───────────────────────────────────────────────────────
  webhookLogs: TransbankWebhookLog[] = [];
  cargandoWebhookLogs = false;

  // ── Panel de Certificación / Pruebas C2C ───────────────────────────────────
  pruebaTerminalId: string = '';
  pruebaMonto: number = 1000;
  pruebaReferencia: string = 'TEST-' + Math.floor(Math.random() * 9000 + 1000);
  pruebaTraceId: string = '';
  pruebaResultado: any = null;
  cargandoPrueba: boolean = false;

  // ── ngx-table ─────────────────────────────────────────────────────────────
  columns: any[] = [];
  
  // ── Pruebas Técnicas en Vivo ──────────────────────────────────────────────
  terminalPruebaId: string = '';
  mensajePrueba: string = 'Test de Impresión Transbank';
  montoPrueba: number = 1000;
  estadoPrueba: string = '';
  transaccionPruebaActiva: any = null;
  private pollingPruebaInterval: any = null;

  configuration: any = {
    ...DefaultConfig,
    searchEnabled: true,
    headerEnabled: true,
    orderEnabled: true,
    paginationEnabled: true,
    exportEnabled: false,
    clickEvent: false,
    selectRow: false,
    rows: 10,
    additionalActions: false,
    serverPagination: false,
    isLoading: false,
    detailsTemplate: false,
    groupRows: false,
    paginationRangeEnabled: true,
    collapseAllRows: false,
    checkboxes: false,
    resizeColumn: false,
    fixedColumnWidth: false,
    horizontalScroll: false,
    draggable: false,
    logger: false,
    showDetailsArrow: false,
    newPagination: false,
  };

  constructor(
    private _tbk: TransbankService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.configurarColumnas();
    this.cargarConfig();
    this.cargarTerminales();
    this.cargarTransacciones();
    this.cargarWebhookLogs();
  }

  ngAfterViewInit(): void {
    this.configurarColumnas();
    this.cdr.detectChanges();
  }

  configurarColumnas(): void {
    this.columns = [
      { key: 'nombre',      title: 'Nombre Terminal',   width: '25%' },
      { key: 'terminalId',  title: 'Terminal ID',        width: '20%' },
      { key: 'sucursal',    title: 'Sucursal',           width: '15%' },
      { key: 'ambiente',    title: 'Ambiente',           width: '15%', cellTemplate: this.frmAmbiente },
      { key: 'acciones',   title: 'Acciones y Pruebas', width: '25%', cellTemplate: this.frmAccion  },
    ];
  }

  ngOnDestroy(): void {
    this.detenerPollingPrueba();
  }

  // ── Config ────────────────────────────────────────────────────────────────

  async cargarConfig() {
    this.cargandoConfig = true;
    try {
      const res: any = await this._tbk.getConfig();
      if (res?.estado && res?.objeto) {
        this.config = res.objeto;
        if (!this.config.integracion) this.config.integracion = { commerceCode: '', apiKey: '' };
        if (!this.config.produccion)  this.config.produccion  = { commerceCode: '', apiKey: '' };
      }
    } catch { }
    this.cargandoConfig = false;
    this.cdr.detectChanges();
  }

  async guardarConfig() {
    this.guardandoConfig = true;
    try {
      const res: any = await this._tbk.saveConfig(this.config);
      if (res?.estado) {
        Swal.fire('Guardado', 'Configuración guardada correctamente.', 'success');
      } else {
        Swal.fire('Error', res?.mensaje || 'No se pudo guardar la configuración.', 'error');
      }
    } catch (e: any) {
      Swal.fire('Error', e?.message || 'Error de conexión.', 'error');
    }
    this.guardandoConfig = false;
    this.cdr.detectChanges();
  }

  // ── Terminales ────────────────────────────────────────────────────────────

  async cargarTerminales() {
    this.cargando = true;
    try {
      const res: any = await this._tbk.getTerminales();
      if (res?.estado && Array.isArray(res?.objeto)) {
        this.terminales = [...res.objeto];
        if (this.terminales.length > 0 && !this.pruebaTerminalId) {
          this.pruebaTerminalId = this.terminales[0].terminalId;
        }
      }
    } catch { }
    this.cargando = false;
    this.cdr.detectChanges();
  }

  crearTerminal() {
    this.terminalSeleccionado = this.nuevoTerminalVacio();
    this.editandoTerminal = true;
  }

  editarTerminal(terminal: TransbankTerminal) {
    this.terminalSeleccionado = { ...terminal };
    this.editandoTerminal = true;
  }

  cancelarEdicion() {
    this.editandoTerminal = false;
    this.terminalSeleccionado = this.nuevoTerminalVacio();
  }

  async guardarTerminal() {
    if (!this.terminalSeleccionado.nombre?.trim()) {
      Swal.fire('Atención', 'El nombre del terminal es requerido.', 'warning');
      return;
    }
    if (!this.terminalSeleccionado.terminalId?.trim()) {
      Swal.fire('Atención', 'El Terminal ID es requerido.', 'warning');
      return;
    }

    this.cargando = true;
    try {
      const res: any = await this._tbk.addEditTerminal(this.terminalSeleccionado);
      if (res?.estado) {
        Swal.fire('Guardado', 'Terminal guardado correctamente.', 'success');
        this.editandoTerminal = false;
        this.cargarTerminales();
      } else {
        Swal.fire('Error', res?.mensaje || 'No se pudo guardar el terminal.', 'error');
      }
    } catch (e: any) {
      Swal.fire('Error', e?.message || 'Error de conexión.', 'error');
    }
    this.cargando = false;
    this.cdr.detectChanges();
  }

  async eliminarTerminal(terminal: TransbankTerminal) {
    const result = await Swal.fire({
      title: '¿Eliminar terminal?',
      text: `Se eliminará el terminal "${terminal.nombre}" (${terminal.terminalId}).`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      this.cargando = true;
      try {
        const res: any = await this._tbk.eliminaTerminal(terminal._id!);
        if (res?.estado) {
          Swal.fire('Eliminado', 'Terminal eliminado correctamente.', 'success');
          this.cargarTerminales();
        } else {
          Swal.fire('Error', res?.mensaje || 'No se pudo eliminar el terminal.', 'error');
        }
      } catch (e: any) {
        Swal.fire('Error', e?.message || 'Error de conexión.', 'error');
      }
      this.cargando = false;
      this.cdr.detectChanges();
    }
  }

  private nuevoTerminalVacio(): TransbankTerminal {
    return {
      nombre: '',
      terminalId: '',
      sucursal: '',
      ambiente: 'INTEGRACION',
      estado: true
    };
  }

  // ── Pruebas de Terminal ───────────────────────────────────────────────────

  async probarImpresionDirecta(row: TransbankTerminal) {
    Swal.fire({
      title: 'Enviando ticket membretado...',
      text: `Imprimiendo en "${row.nombre}" (TID: ${row.terminalId})...`,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const res = await this._tbk.imprimir(row.terminalId, this.mensajePrueba);
      Swal.close();
      if (res?.estado) {
        Swal.fire({
          icon: 'success',
          title: '¡Impresión Exitosa!',
          text: 'El comprobante oficial de Consultora INDESAD SpA fue impreso correctamente en el POS.'
        });
      } else {
        Swal.fire('Error de Impresión', res?.mensaje || 'El terminal no pudo imprimir el mensaje.', 'error');
      }
    } catch (e: any) {
      Swal.close();
      Swal.fire('Error', e?.message || 'Error de comunicación.', 'error');
    }
  }

  async probarCobroDirecto(row: TransbankTerminal) {
    const { value: montoIngresado } = await Swal.fire({
      title: 'Probar Cobro en POS',
      html: `
        <div class="text-start small mb-3">
          <p class="mb-1"><strong>Terminal:</strong> ${row.nombre} (<code>${row.terminalId}</code>)</p>
          <p class="mb-2"><strong>Ambiente:</strong> <span class="badge ${row.ambiente === 'PRODUCCION' ? 'bg-success' : 'bg-warning'}">${row.ambiente}</span></p>
          <div class="alert alert-info py-2 px-3 mb-2 small text-dark">
            <i class="fas fa-info-circle me-1"></i> Selecciona un monto rápido o escribe el valor deseado:
          </div>
          <div class="d-flex gap-2 justify-content-center my-2 flex-wrap">
            <button type="button" class="btn btn-outline-warning btn-xs fw-bold px-2 py-1" onclick="const inp = document.querySelector('.swal2-input'); if(inp){ inp.value = '50'; inp.focus(); }">$50</button>
            <button type="button" class="btn btn-outline-warning btn-xs fw-bold px-2 py-1" onclick="const inp = document.querySelector('.swal2-input'); if(inp){ inp.value = '100'; inp.focus(); }">$100</button>
            <button type="button" class="btn btn-outline-warning btn-xs fw-bold px-2 py-1" onclick="const inp = document.querySelector('.swal2-input'); if(inp){ inp.value = '500'; inp.focus(); }">$500</button>
            <button type="button" class="btn btn-outline-warning btn-xs fw-bold px-2 py-1" onclick="const inp = document.querySelector('.swal2-input'); if(inp){ inp.value = '1000'; inp.focus(); }">$1.000</button>
          </div>
          <label class="form-label small fw-bold mt-2">Monto a cobrar ($ CLP):</label>
        </div>
      `,
      input: 'number',
      inputValue: 100,
      inputAttributes: {
        min: '1',
        step: '1',
        placeholder: 'Ej: 100'
      },
      showCancelButton: true,
      confirmButtonText: '<i class="fas fa-paper-plane me-1"></i> Enviar al POS',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#f39c12',
      inputValidator: (value) => {
        if (!value || parseInt(value, 10) <= 0) {
          return 'Debes ingresar un monto válido mayor a $0.';
        }
        return null;
      }
    });

    if (!montoIngresado) return;

    const monto = parseInt(montoIngresado, 10);
    const ref = 'TEST-' + Math.floor(Math.random() * 9000 + 1000);
    this.iniciarCobroGenerico(row, monto, ref);
  }

  async iniciarCobroGenerico(terminal: TransbankTerminal, monto: number, ref: string) {
    Swal.fire({
      title: `Iniciando cobro de $${monto.toLocaleString('es-CL')}...`,
      text: `Enviando solicitud al terminal "${terminal.nombre}"...`,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const res = await this._tbk.cobrar(terminal.terminalId, monto, ref);
      Swal.close();

      if (!res?.estado || !res?.transaccionId) {
        Swal.fire('Error al iniciar cobro', res?.mensaje || 'No se pudo enviar la orden al POS.', 'error');
        return;
      }

      this.transaccionPruebaActiva = {
        id: res.transaccionId,
        traceId: res.traceId,
        terminal: terminal,
        monto: monto,
        referencia: ref,
        rawResponse: res.rawResponse || JSON.stringify(res, null, 2)
      };

      this.pruebaTraceId = res.traceId;
      this.mostrarModalEsperaCobro();

    } catch (e: any) {
      Swal.close();
      Swal.fire('Error', e?.message || 'Error al conectar con la API.', 'error');
    }
  }

  ultimoStatusLive: string = '';

  copiarUltimoStatusLive() {
    this.copiarTexto(this.ultimoStatusLive || '{}', 'Payload STATUS');
  }

  async forzarConsultaStatusLive() {
    if (!this.transaccionPruebaActiva?.id) return;
    try {
      const res = await this._tbk.consultarResultado(this.transaccionPruebaActiva.id);
      this.actualizarDOMStatusLive(res);
      Swal.showValidationMessage ? null : null;
    } catch { }
  }

  actualizarDOMStatusLive(res: any) {
    const raw = res?.rawStatus || res?.ultimoStatusJson || (res?.objeto ? JSON.stringify(res.objeto, null, 2) : '');
    if (raw) {
      this.ultimoStatusLive = raw;
      const pre = document.getElementById('tbkPreLiveStatus');
      if (pre) {
        try {
          pre.innerText = JSON.stringify(JSON.parse(raw), null, 2);
        } catch {
          pre.innerText = raw;
        }
      }
    }

    const estadoEnVivo = res?.estadoEnVivo || res?.objeto?.estadoEnVivo || res?.objeto?.estado || '';
    const badge = document.getElementById('tbkBadgeEstadoEnVivo');
    if (badge && estadoEnVivo) {
      badge.innerText = estadoEnVivo;
      badge.className = `badge ${estadoEnVivo === 'APROBADO' ? 'bg-success' : estadoEnVivo === 'CANCELADO' ? 'bg-secondary' : estadoEnVivo === 'RECHAZADO' ? 'bg-danger' : 'bg-primary'} fs-6`;
    }

    const detalle = document.getElementById('tbkDetalleStatusTexto');
    if (detalle) {
      if (estadoEnVivo.includes('PIN')) {
        detalle.innerText = '💳 El terminal está solicitando el PIN al cliente...';
      } else if (estadoEnVivo.includes('CUOTA')) {
        detalle.innerText = '📊 El terminal está en la pantalla de selección de cuotas...';
      } else if (estadoEnVivo.includes('PROPINA')) {
        detalle.innerText = '💰 El terminal está solicitando propina...';
      } else if (estadoEnVivo.includes('VUELTO')) {
        detalle.innerText = '💵 El terminal está en la pantalla de solicitar vuelto...';
      } else if (estadoEnVivo === 'PENDIENTE' || estadoEnVivo.includes('TARJETA') || estadoEnVivo.includes('INICIALIZADO')) {
        detalle.innerText = 'Pasa, inserta o acerca la tarjeta en la maquinita física...';
      }
    }
  }

  mostrarModalEsperaCobro() {
    if (!this.transaccionPruebaActiva) return;

    const t = this.transaccionPruebaActiva;
    this.ultimoStatusLive = t.rawResponse || JSON.stringify(t, null, 2);
    (window as any).__transaccionActualTBK = t;
    (window as any).__componentTBK = this;

    Swal.fire({
      title: `Esperando pago en POS: $${t.monto.toLocaleString('es-CL')}`,
      width: '720px',
      html: `
        <div class="py-2 text-start small">
          <!-- Info de Terminal e IDs -->
          <div class="p-3 bg-dark rounded border border-secondary mb-3">
            <div class="d-flex justify-content-between mb-1">
              <strong>Terminal:</strong> <span>${t.terminal.nombre} (TID: <code>${t.terminal.terminalId}</code>)</span>
            </div>
            <div class="d-flex justify-content-between mb-1">
              <strong>Host ID / Referencia:</strong> <span class="text-warning font-monospace fw-bold">${t.referencia}</span>
            </div>
            <div class="d-flex justify-content-between mb-1">
              <strong>Trace ID (Transbank):</strong> <span class="text-info font-monospace text-break" style="font-size: 11px;">${t.traceId}</span>
            </div>
            <div class="d-flex justify-content-between">
              <strong>ID MongoDB:</strong> <span class="text-muted font-monospace" style="font-size: 11px;">${t.id}</span>
            </div>
          </div>

          <!-- Monitor de STATUS en Vivo -->
          <div class="p-3 bg-dark rounded border border-info mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold text-info"><i class="fas fa-satellite-dish me-1"></i> Estado del POS en Vivo:</span>
              <span id="tbkBadgeEstadoEnVivo" class="badge bg-primary fs-6">INICIALIZADO (Esperando tarjeta)</span>
            </div>
            <div id="tbkDetalleStatusTexto" class="text-muted small mb-2">
              Pasa, inserta o acerca la tarjeta en la maquinita física...
            </div>
            <div class="d-flex justify-content-between align-items-center mb-1">
              <strong class="text-light" style="font-size: 11px;">Último Payload de STATUS recibido:</strong>
              <button type="button" class="btn btn-xs btn-outline-info" onclick="window.__componentTBK.copiarUltimoStatusLive()">
                📋 Copiar este JSON
              </button>
            </div>
            <pre id="tbkPreLiveStatus" class="bg-black text-info p-2 rounded mb-0" style="max-height: 130px; overflow: auto; font-size: 10px; text-align: left;">${t.rawResponse || '(Sincronizando con el POS...)'}</pre>
          </div>

          <!-- Botones de Acción y Copia para Excel -->
          <div class="d-flex gap-2 justify-content-center flex-wrap mb-3">
            <button type="button" class="btn btn-success btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${t.traceId}', window.__componentTBK.ultimoStatusLive, 'EXITOSA')">
              📊 Copiar Fila para Excel (Último STATUS)
            </button>
            <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${t.traceId}', 'Trace ID')">
              📋 Copiar Trace ID
            </button>
            <button type="button" class="btn btn-outline-warning btn-sm fw-bold text-dark" onclick="window.__componentTBK.copiarTexto('${t.referencia}', 'Host ID')">
              📋 Copiar Host ID
            </button>
            <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(window.__componentTBK.ultimoStatusLive, 'JSON STATUS')">
              📋 Copiar JSON STATUS
            </button>
            <button type="button" class="btn btn-secondary btn-sm fw-bold text-white" onclick="window.__componentTBK.forzarConsultaStatusLive()">
              🔄 Consultar STATUS Ahora
            </button>
          </div>

          <div class="text-center my-2">
            <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
            <span class="text-muted small">Sincronizando estado con Transbank cada 2 segundos...</span>
          </div>
        </div>
      `,
      showCancelButton: true,
      cancelButtonText: '🚫 Cancelar cobro desde la Web',
      cancelButtonColor: '#d33',
      showConfirmButton: false,
      allowOutsideClick: false
    }).then(async (result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        await this.cancelarCobroPrueba();
      }
    });

    this.iniciarPollingPrueba();
  }

  iniciarPollingPrueba() {
    this.detenerPollingPrueba();

    this.pollingPruebaInterval = setInterval(async () => {
      if (!this.transaccionPruebaActiva?.id) return;

      try {
        const res = await this._tbk.consultarResultado(this.transaccionPruebaActiva.id);
        this.actualizarDOMStatusLive(res);

        const tx = res?.objeto;

        if (tx && tx.estado !== 'PENDIENTE') {
          this.detenerPollingPrueba();
          Swal.close();

          (window as any).__txResultado = tx;
          (window as any).__componentTBK = this;

          const jsonPretty = JSON.stringify(tx, null, 2);

          if (tx.estado === 'APROBADO') {
            Swal.fire({
              icon: 'success',
              title: '¡Pago APROBADO en el POS!',
              width: '650px',
              html: `
                <div class="text-start small">
                  <div class="p-3 bg-dark rounded border border-success mb-3">
                    <p class="mb-1"><strong>Monto:</strong> $${tx.totalPayment?.toLocaleString('es-CL')}</p>
                    <p class="mb-1"><strong>Trace ID:</strong> <code class="text-info">${tx.traceId}</code></p>
                    <p class="mb-1"><strong>N° Autorización:</strong> <strong class="text-success">${tx.authorizationCode || 'N/A'}</strong></p>
                    <p class="mb-1"><strong>Tarjeta:</strong> ${tx.cardType || ''} ****${tx.last4Digits || ''} (${TransbankService.describeCardType(tx.cardType)})</p>
                  </div>
                  <div class="d-flex gap-2 justify-content-center flex-wrap mb-2">
                    <button type="button" class="btn btn-success btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${tx.traceId}', window.__txResultado, 'EXITOSA')">
                      📊 Copiar Fila para Excel (Cols E, F, G)
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${tx.traceId}', 'Trace ID')">
                      📋 Copiar Trace ID
                    </button>
                    <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__txResultado, null, 2), 'JSON Response')">
                      📋 Copiar JSON Response
                    </button>
                  </div>
                  <pre class="bg-dark text-light p-2 rounded mt-2" style="max-height: 160px; overflow: auto; font-size: 11px;">${jsonPretty}</pre>
                </div>
              `,
              confirmButtonText: 'Cerrar'
            });
          } else if (tx.estado === 'CANCELADO') {
            Swal.fire({
              icon: 'info',
              title: 'Cobro Cancelado en el POS',
              width: '650px',
              html: `
                <div class="text-start small">
                  <div class="p-3 bg-dark rounded border border-secondary mb-3">
                    <p class="mb-1"><strong>Trace ID:</strong> <code class="text-info">${tx.traceId}</code></p>
                    <p class="mb-1"><strong>Estado:</strong> <span class="badge bg-secondary">CANCELADO</span></p>
                    <p class="mb-1"><strong>Mensaje:</strong> ${tx.mensajeError || 'Cancelado por el operador o POS'}</p>
                  </div>
                  <div class="d-flex gap-2 justify-content-center flex-wrap mb-2">
                    <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${tx.traceId}', window.__txResultado, 'EXITOSA')">
                      📊 Copiar Fila para Excel
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${tx.traceId}', 'Trace ID')">
                      📋 Copiar Trace ID
                    </button>
                    <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__txResultado, null, 2), 'JSON Response')">
                      📋 Copiar JSON Response
                    </button>
                  </div>
                  <pre class="bg-dark text-light p-2 rounded mt-2" style="max-height: 160px; overflow: auto; font-size: 11px;">${jsonPretty}</pre>
                </div>
              `,
              confirmButtonText: 'Cerrar'
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Cobro Rechazado o Fallido',
              width: '650px',
              html: `
                <div class="text-start small">
                  <div class="p-3 bg-dark rounded border border-danger mb-3">
                    <p class="mb-1"><strong>Trace ID:</strong> <code class="text-info">${tx.traceId}</code></p>
                    <p class="mb-1"><strong>Estado:</strong> <span class="badge bg-danger">${tx.estado}</span></p>
                    <p class="mb-1"><strong>Mensaje / Glosa:</strong> ${tx.mensajeError || 'Rechazado'}</p>
                  </div>
                  <div class="d-flex gap-2 justify-content-center flex-wrap mb-2">
                    <button type="button" class="btn btn-warning btn-sm fw-bold text-dark" onclick="window.__componentTBK.copiarFilaExcel('${tx.traceId}', window.__txResultado, 'FALLIDA')">
                      📊 Copiar Fila para Excel
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${tx.traceId}', 'Trace ID')">
                      📋 Copiar Trace ID
                    </button>
                    <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__txResultado, null, 2), 'JSON Response')">
                      📋 Copiar JSON Response
                    </button>
                  </div>
                  <pre class="bg-dark text-light p-2 rounded mt-2" style="max-height: 160px; overflow: auto; font-size: 11px;">${jsonPretty}</pre>
                </div>
              `,
              confirmButtonText: 'Cerrar'
            });
          }

          this.transaccionPruebaActiva = null;
          this.cargarTransacciones();
          this.cargarWebhookLogs();
        }
      } catch { }
    }, 2000);
  }

  detenerPollingPrueba() {
    if (this.pollingPruebaInterval) {
      clearInterval(this.pollingPruebaInterval);
      this.pollingPruebaInterval = null;
    }
  }

  async cancelarCobroPrueba() {
    if (!this.transaccionPruebaActiva?.id) return;
    this.detenerPollingPrueba();

    Swal.fire({
      title: 'Cancelando en el POS...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const res = await this._tbk.anular(this.transaccionPruebaActiva.id);
      Swal.close();

      (window as any).__resAnulacion = res;
      (window as any).__componentTBK = this;

      if (res?.estado) {
        Swal.fire({
          icon: 'info',
          title: 'Cancelación Solicitada',
          width: '650px',
          html: `
            <div class="text-start small">
              <p class="mb-2">${res.mensaje || 'Transacción cancelada correctamente en el POS.'}</p>
              <p class="mb-1"><strong>Trace ID:</strong> <code>${res.traceId || this.transaccionPruebaActiva.traceId}</code></p>
              <div class="d-flex gap-2 justify-content-center flex-wrap my-3">
                <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${res.traceId || this.transaccionPruebaActiva.traceId}', window.__resAnulacion, 'EXITOSA')">
                  📊 Copiar Fila para Excel
                </button>
                <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${res.traceId || this.transaccionPruebaActiva.traceId}', 'Trace ID')">
                  📋 Copiar Trace ID
                </button>
                <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__resAnulacion, null, 2), 'JSON Response')">
                  📋 Copiar JSON Response
                </button>
              </div>
              <pre class="bg-dark text-light p-2 rounded" style="max-height: 160px; overflow: auto; font-size: 11px;">${res.rawResponse || JSON.stringify(res, null, 2)}</pre>
            </div>
          `,
          confirmButtonText: 'Cerrar'
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error al cancelar',
          text: res?.mensaje || 'No se pudo cancelar la orden.',
          confirmButtonText: 'Cerrar'
        });
      }
    } catch (e: any) {
      Swal.close();
      Swal.fire('Error', e?.message || 'Error de conexión.', 'error');
    }
    this.transaccionPruebaActiva = null;
    this.cargarTransacciones();
    this.cargarWebhookLogs();
  }

  // ── Métodos del Panel de Pruebas C2C ──────────────────────────────────────

  generarNuevaReferencia() {
    this.pruebaReferencia = 'TEST-' + Math.floor(Math.random() * 9000 + 1000);
    this.cdr.detectChanges();
  }

  async ejecutarCobroPrueba() {
    const term = this.terminales.find(t => t.terminalId === this.pruebaTerminalId);
    if (!term) {
      Swal.fire('Atención', 'Selecciona un terminal para la prueba.', 'warning');
      return;
    }
    this.iniciarCobroGenerico(term, this.pruebaMonto || 1000, this.pruebaReferencia);
  }

  async ejecutarConsultaEstadoDirecto() {
    if (!this.pruebaTraceId?.trim()) {
      Swal.fire('Atención', 'Ingresa el Trace ID que deseas consultar.', 'warning');
      return;
    }

    const term = this.terminales.find(t => t.terminalId === this.pruebaTerminalId);
    const ambiente = term?.ambiente || 'INTEGRACION';

    this.cargandoPrueba = true;
    this.cdr.detectChanges();

    try {
      const res = await this._tbk.consultarEstadoDirecto(this.pruebaTraceId.trim(), ambiente);
      this.pruebaResultado = res;

      (window as any).__resStatus = res;
      (window as any).__componentTBK = this;

      Swal.fire({
        title: `Estado Directo Transbank (GET /estado)`,
        width: '700px',
        html: `
          <div class="text-start small">
            <p class="mb-1"><strong>Trace ID:</strong> <code>${this.pruebaTraceId}</code></p>
            <p class="mb-1"><strong>HTTP Status:</strong> <span class="badge ${res.httpStatusCode === 200 ? 'bg-success' : 'bg-danger'}">${res.httpStatusCode || 'N/A'}</span></p>
            <div class="d-flex gap-2 justify-content-center flex-wrap my-3">
              <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${this.pruebaTraceId}', window.__resStatus, 'EXITOSA')">
                📊 Copiar Fila para Excel (Cols E, F, G)
              </button>
              <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${this.pruebaTraceId}', 'Trace ID')">
                📋 Copiar Trace ID
              </button>
              <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__resStatus, null, 2), 'JSON Response')">
                📋 Copiar JSON Response
              </button>
            </div>
            <pre class="bg-dark text-light p-2 rounded" style="max-height: 220px; overflow: auto; font-size: 11px;">${res.rawResponse || JSON.stringify(res, null, 2)}</pre>
          </div>
        `,
        confirmButtonText: 'Cerrar'
      });
    } catch (e: any) {
      Swal.fire('Error', e?.message || 'Error al consultar estado.', 'error');
    }

    this.cargandoPrueba = false;
    this.cdr.detectChanges();
  }

  async ejecutarCancelarDirecto() {
    if (!this.pruebaTraceId?.trim()) {
      Swal.fire('Atención', 'Ingresa el Trace ID que deseas cancelar.', 'warning');
      return;
    }

    const term = this.terminales.find(t => t.terminalId === this.pruebaTerminalId);
    const ambiente = term?.ambiente || 'INTEGRACION';

    this.cargandoPrueba = true;
    this.cdr.detectChanges();

    try {
      const res = await this._tbk.cancelarDirecto(this.pruebaTraceId.trim(), ambiente);
      this.pruebaResultado = res;

      (window as any).__resCancel = res;
      (window as any).__componentTBK = this;

      Swal.fire({
        title: `Respuesta de Cancelación (PATCH /cancelar)`,
        width: '700px',
        html: `
          <div class="text-start small">
            <p class="mb-1"><strong>Trace ID:</strong> <code>${this.pruebaTraceId}</code></p>
            <p class="mb-1"><strong>HTTP Status:</strong> <span class="badge ${res.httpStatusCode === 200 || res.httpStatusCode === 204 ? 'bg-success' : 'bg-warning'}">${res.httpStatusCode || 'N/A'}</span></p>
            <div class="d-flex gap-2 justify-content-center flex-wrap my-3">
              <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${this.pruebaTraceId}', window.__resCancel, 'EXITOSA')">
                📊 Copiar Fila para Excel (Cols E, F, G)
              </button>
              <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${this.pruebaTraceId}', 'Trace ID')">
                📋 Copiar Trace ID
              </button>
              <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__resCancel, null, 2), 'JSON Response')">
                📋 Copiar JSON Response
              </button>
            </div>
            <pre class="bg-dark text-light p-2 rounded" style="max-height: 220px; overflow: auto; font-size: 11px;">${res.rawResponse || JSON.stringify(res, null, 2)}</pre>
          </div>
        `,
        confirmButtonText: 'Cerrar'
      });
    } catch (e: any) {
      Swal.fire('Error', e?.message || 'Error al solicitar cancelación.', 'error');
    }

    this.cargandoPrueba = false;
    this.cdr.detectChanges();
  }

  // ── Helpers de Copia para Excel y Portapapeles ────────────────────────────

  copiarFilaExcel(traceId: string, response: any, estado: string = 'EXITOSA') {
    let respStr = typeof response === 'string' ? response : JSON.stringify(response);
    // Eliminar retornos de carro para una celda limpia en Excel
    respStr = respStr.replace(/[\r\n\t]+/g, ' ');
    const fila = `${traceId || ''}\t${respStr || ''}\t${estado || 'EXITOSA'}`;

    navigator.clipboard.writeText(fila).then(() => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: '¡Fila copiada para Excel!',
        text: 'Haz clic en la columna E (Trace ID) de tu Excel y presiona Ctrl + V para pegar Trace ID, Response y Estado.',
        showConfirmButton: false,
        timer: 4500
      });
    });
  }

  copiarTexto(texto: string, etiqueta: string = 'Texto') {
    navigator.clipboard.writeText(texto).then(() => {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: `¡${etiqueta} copiado al portapapeles!`,
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  // ── Gestión de Pestañas y Auditoría ──────────────────────────────────────

  cambiarTab(tab: 'terminales' | 'transacciones' | 'webhook' | 'pruebas') {
    this.tabActiva = tab;
    if (tab === 'transacciones') {
      this.cargarTransacciones();
    } else if (tab === 'webhook') {
      this.cargarWebhookLogs();
    }
    this.cdr.detectChanges();
  }

  async cargarTransacciones() {
    this.cargandoTransacciones = true;
    this.cdr.detectChanges();
    try {
      const res: any = await this._tbk.getTransacciones();
      if (res?.estado && Array.isArray(res?.objeto)) {
        this.transacciones = [...res.objeto];
      }
    } catch { }
    this.cargandoTransacciones = false;
    this.cdr.detectChanges();
  }

  async cargarWebhookLogs() {
    this.cargandoWebhookLogs = true;
    this.cdr.detectChanges();
    try {
      const res: any = await this._tbk.getWebhookLogs();
      if (res?.estado && Array.isArray(res?.objeto)) {
        this.webhookLogs = [...res.objeto];
      }
    } catch { }
    this.cargandoWebhookLogs = false;
    this.cdr.detectChanges();
  }

  verDetalleWebhook(log: TransbankWebhookLog) {
    let rawFormatted = log.rawBody;
    try {
      rawFormatted = JSON.stringify(JSON.parse(log.rawBody), null, 2);
    } catch { }

    (window as any).__logDetalle = log;
    (window as any).__componentTBK = this;

    Swal.fire({
      title: 'Detalle de Payload Webhook',
      width: '750px',
      html: `
        <div class="text-start small">
          <p class="mb-1"><strong>Fecha:</strong> ${log.fecha}</p>
          <p class="mb-1"><strong>IP Origen:</strong> ${log.ip || 'N/A'}</p>
          <p class="mb-1"><strong>Trace ID:</strong> <code class="text-info">${log.traceId || log.transactionHostId || 'N/A'}</code></p>
          <p class="mb-1"><strong>Resultado:</strong> <span class="badge ${log.resultadoProcesamiento?.includes('actualizada a APROBADO') ? 'bg-success' : 'bg-info'}">${log.resultadoProcesamiento || 'N/A'}</span></p>
          <div class="d-flex gap-2 justify-content-center flex-wrap my-3">
            <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${log.traceId || log.transactionHostId}', window.__logDetalle.rawBody, '${log.resultadoProcesamiento?.includes('APROBADO') ? 'EXITOSA' : 'FALLIDA'}')">
              📊 Copiar Fila para Excel (Cols E, F, G)
            </button>
            <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${log.traceId || log.transactionHostId}', 'Trace ID')">
              📋 Copiar Trace ID
            </button>
            <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(window.__logDetalle.rawBody, 'JSON Webhook')">
              📋 Copiar JSON Crudo
            </button>
          </div>
          <hr class="my-2">
          <strong>JSON Crudo Recibido:</strong>
          <pre class="bg-dark text-light p-2 rounded mt-1" style="max-height: 220px; overflow: auto; font-size: 11px; text-align: left;">${rawFormatted || '(Vacío)'}</pre>
          <strong class="mt-2 d-block">Headers:</strong>
          <pre class="bg-dark text-muted p-2 rounded mt-1" style="max-height: 100px; overflow: auto; font-size: 10px; text-align: left;">${log.headers || '(Sin headers capturados)'}</pre>
        </div>
      `,
      confirmButtonText: 'Cerrar'
    });
  }

  verVoucherTransaccion(tx: TransbankTransaccion) {
    (window as any).__txDetalle = tx;
    (window as any).__componentTBK = this;

    const jsonPretty = JSON.stringify(tx, null, 2);

    Swal.fire({
      title: `Transacción: ${tx.transactionHostId || tx.traceId}`,
      width: '650px',
      html: `
        <div class="text-start small">
          <div class="p-3 bg-dark rounded border border-secondary mb-3">
            <p class="mb-1"><strong>Terminal:</strong> ${tx.terminalNombre} (TID: ${tx.terminalId})</p>
            <p class="mb-1"><strong>Monto:</strong> $${tx.totalPayment?.toLocaleString('es-CL')}</p>
            <p class="mb-1"><strong>Estado:</strong> <span class="badge ${tx.estado === 'APROBADO' ? 'bg-success' : tx.estado === 'RECHAZADO' ? 'bg-danger' : 'bg-secondary'}">${tx.estado}</span></p>
            <p class="mb-1"><strong>N° Autorización:</strong> ${tx.authorizationCode || 'N/A'}</p>
            <p class="mb-1"><strong>Tarjeta:</strong> ${tx.cardType || ''} ****${tx.last4Digits || ''} (${TransbankService.describeCardType(tx.cardType)})</p>
            <p class="mb-1"><strong>Fecha:</strong> ${tx.fechaCreacion || 'N/A'}</p>
            <p class="mb-1"><strong>Trace ID:</strong> <code class="text-info">${tx.traceId || 'N/A'}</code></p>
          </div>
          <div class="d-flex gap-2 justify-content-center flex-wrap mb-3">
            <button type="button" class="btn btn-primary btn-sm fw-bold" onclick="window.__componentTBK.copiarFilaExcel('${tx.traceId}', window.__txDetalle.ultimoStatusJson || window.__txDetalle, '${tx.estado === 'APROBADO' ? 'EXITOSA' : 'FALLIDA'}')">
              📊 Copiar Fila para Excel (Cols E, F, G)
            </button>
            <button type="button" class="btn btn-outline-info btn-sm fw-bold" onclick="window.__componentTBK.copiarTexto('${tx.traceId}', 'Trace ID')">
              📋 Copiar Trace ID
            </button>
            <button type="button" class="btn btn-dark btn-sm text-white fw-bold" onclick="window.__componentTBK.copiarTexto(JSON.stringify(window.__txDetalle, null, 2), 'JSON Transacción')">
              📋 Copiar JSON
            </button>
          </div>
          <pre class="bg-dark text-light p-2 rounded" style="max-height: 160px; overflow: auto; font-size: 11px;">${jsonPretty}</pre>
        </div>
      `,
      confirmButtonText: 'Cerrar'
    });
  }
}
